module.exports = __webpack_public_path__ + "img/Dean Odle.7fc5ac65.jpg";